import { useMutation } from '@tanstack/react-query';

import { PREFIX_URL } from '@/src/api/config';
import { axios } from '@/src/lib/axios/axios';
import { MutationConfig, queryClient } from '@/src/lib/react-query/react-query';
import { generateRoutePath } from '@/src/routes';

import { getFilesQueryKey } from './getFiles';
import { getFoldersQueryKey } from './getFolders';
import { getRootFilesQueryKey } from './getRootFiles';

const url = `${PREFIX_URL}/projects/:projectId/library/folders`;

type CreateFolderResponse = { status: boolean; reason?: string; item: { id: number } };
type CreateFolderDTO = {
  name: string;
  parentId: number;
  projectId: number;
};

export const createFolder = ({
  name,
  parentId,
  projectId,
}: CreateFolderDTO): Promise<CreateFolderResponse> => {
  const URL = generateRoutePath(url, { projectId });

  return axios.post(URL, { name, 'parent-id': parentId });
};

type UseCreateFolderOptions = {
  config?: MutationConfig<typeof createFolder>;
};

export const useCreateFolder = ({ config }: UseCreateFolderOptions = {}) => {
  return useMutation({
    ...config,
    onSuccess: (response) => {
      if (!response.status) {
        return;
      }

      queryClient.invalidateQueries({ queryKey: getFilesQueryKey.list });
      queryClient.invalidateQueries({ queryKey: getFoldersQueryKey.list });
      queryClient.invalidateQueries({ queryKey: getRootFilesQueryKey.list });
    },
    mutationFn: (props) => createFolder(props),
  });
};
